import {action, makeAutoObservable} from "mobx"
import ExportHistoryApi, {LaunchAnswer} from "../../api/ExportHistoryApi"


export interface productStatus {
    offer_id: string
    product_id: number
    shop_product_id: string
    name: string
    status: string
    errors_count: number
    errors: any[]
    category_id: string | undefined
}

class ExportStatusController {
    private _products: productStatus[] = []
    task_ids: any[] = []
    private _launch_id: number | undefined
    launches: LaunchAnswer[] = []
    private _page = 0
    private _l_page = 0
    private _pageCount = 100
    private _l_pageCount = 30
    private _countOfPages = 0
    private _l_countOfPages = 0
    private _loadStarted = false
    private _loadFinished = false

    get countOfPages(): number {
        return this._countOfPages
    }

    get pageCount(): number {
        return this._pageCount
    }

    get page(): number {
        return this._page
    }
    get lCountOfPages(): number {
        return Math.ceil(this._products.length / this.lPageCount)
    }

    get lPageCount(): number {
        return this._l_pageCount
    }

    get lPage(): number {
        return this._l_page
    }

    set lPage(page:number) {
        this._l_page = page
    }

    get products(): productStatus[] {
        return this._products.slice(this.lPage * this.lPageCount, (this.lPage + 1) * this.lPageCount)
    }

    constructor() {
        makeAutoObservable(this)
    }

    _productsLoaded: boolean = false

    get productsLoaded(): boolean {
        return this._productsLoaded
    }

    get loadFinished(): boolean {
        return this._loadFinished
    }

    get historyLoaded(): boolean {
        return this.launches && this.launches.length > 0
    }

    get launchId(): number|undefined{
        return this._launch_id
    }

    isNewLaunch(launch_id: string) {
        if(+launch_id !== this._launch_id) {
            this._productsLoaded = false
        }

        return !this.productsLoaded
    }

    loadHistory(page = 0){
        if (+this._page === +page && this._loadStarted) {
            return false
        }
        this._loadStarted = true
        this._page = page
        ExportHistoryApi.history({page: this._page,
            pageCount: this._pageCount,}).then(action("exportHistoryLoaded",(result) => {
            this._loadStarted = false
            this.launches = result.data.data.launches
            this._countOfPages = result.data.data.totalPages
        }))
    }

    loadLaunchData(data?: { launch_id: string }) {
        if (data) {
            this._launch_id = +data.launch_id
        }

        ExportHistoryApi.launchData(this.launchId).then((result) => {
                this._products = result.data.data.products
                this.task_ids = result.data.data.task_ids
                for(const product of this._products) {
                    product.errors_count = product.errors.length
                }
                this._productsLoaded = true
            }
        )
    }
}

const exportStatusController = new ExportStatusController()
export default exportStatusController